import { LockOutlined } from '@ant-design/icons'
import { checkVisualizeEnabled, useMe } from '@salescore/client-common'
import { OverlaySection } from '@salescore/frontend-common'
import { t } from 'i18next'
import type { ReactElement } from 'react'

export const VisualizeOnlySection = ({ children }: { children: ReactElement }): ReactElement => {
  const me = useMe()
  const isVisualizeEnabled = checkVisualizeEnabled(me.myUser)

  return (
    <OverlaySection
      disabled={!isVisualizeEnabled}
      message={
        <>
          <LockOutlined style={{ fontSize: 30 }} />
          <br />
          {t(`VISUALIZEライセンスがないため、KPIを作成できません。`)}
        </>
      }
    >
      {children}
    </OverlaySection>
  )
}
